import { trackEvent } from '~/utils';

export type FunnelEventParams = Record<string, string | number | boolean>;

export const trackFunnelEvent = (name: string, params: FunnelEventParams = {}) => {
  trackEvent(name, { event_category: 'trip_funnel', event_label: name, ...params });
};

export const trackClickEvent = (name: string) => {
  trackEvent(name, { event_category: 'click', event_label: name });
};
